import React from 'react';

// Renomeado de country_badge.jsx pra CountryBadge.jsx (fase 3c) — todos os 4 call sites atualizados.
const CountryBadge = ({ code, size = 20, className = '' }) => {
  // Handle cases where code might be undefined or null
  if (!code) {
    return null;
  }

  // Convert to lowercase for file naming convention
  const flagCode = code.toLowerCase();
  
  // Construct the path to the SVG file
  const flagPath = `/static/travel-static/circle-flags/${flagCode}.svg`;

  return (
    <img
      src={flagPath}
      alt={`${code} flag`}
      className={`rounded-full ${className}`}
      style={{
        width: size,
        height: size,
        minWidth: size,
        minHeight: size
      }}
      onError={(e) => {
        // Fallback for missing flags - hide the image
        e.target.style.display = 'none';
      }}
    />
  );
};

export default CountryBadge;
